import Http from '../Http';

export class CodigoPostalService {
  static async obtenerLista(page = 0, limit = 15, filters: Record<string, string> = {}, orderBy = '', order = 'asc') {
    const body: any = {
      p: page,
      l: limit
    };
    
    if (Object.keys(filters).length) {
      body.q = filters;
    }
    if (orderBy) {
      body.orderBy = orderBy;
      body.order = order;
    }

    try {
      const res = await Http.post(`codigo-postal/filter`, body);
      return res.data?.rows || res.data || [];
    } catch (e) {
      console.error(e);
      return [];
    }
  }
}
